import appAxios from "services/axios";

class TouristsAdminService {
  async getTouristsByTourPackageID(tourPackageID: string) {
    return appAxios.get(`/admin/orgs/${localStorage.getItem("orgID")}/tourists/${tourPackageID}`);
  };
}

export default new TouristsAdminService();
